<div [hidden]="savedCardsList && savedCardsList.length == 0" class="app-saved-card"
[attr.style]="settingsData?.bg_secondary_color ? 'background-color: ' + settingsData.bg_secondary_color + ' !important;' : '' "
    [ngClass]="{'mar-t-0':router.url.includes('/stream/') || router.url.includes('/album/video/') || router.url.includes('/album/audio/'),'p-10':settingsData?.bg_secondary_color}">
    <h6 class="fs-16 w-100"
        [ngStyle]="{ 'color': settingsData?.font_secondary_color ? settingsData?.font_secondary_color : settingsData?.font_secondary_color , 'font-family': settingsData?.font_family ? settingsData?.font_family : ''}">
        Saved Credit/Debit card</h6>
       
    <div class="row col-12 align-items-center no-gutters mb-10 plr-0"
        *ngFor="let card of savedCardsList">
        <div class="col-12 row ml-1 card-block align-center"
        [attr.style]="(settingsData?.bg_primary_color ? 
        'background-color: ' + settingsData.bg_primary_color + ' !important; ' : '') +
        (settingsData?.font_tertiary_color ? 'border: 1px solid ' + settingsData.font_tertiary_color + ' !important;' : '')"

            [ngClass]="{'selected-card':card.selectedCard,'col-lg-12':router.url.includes('/stream/') || router.url.includes('/album/video/') ||  router.url.includes('/album/audio/'),'mb-10':router.url.includes('/album/video/') || router.url.includes('/album/audio/')}">
            <div class="col-5 col-md-5 pl-0">
                <mat-radio-group name="card" class="mr-3 saved-card-radio" [ngClass]="{'d-block pb-10': deviceInfo != 'web'}" [style.--radio-border-color]="settingsData?.font_secondary_color"
                    [style.--saved-card-radio-color]="cardRadioColor">
                    <mat-radio-button [value]="card?.id" (click)="selectCard($event,card)" [checked]="card.selectedCard"
                    [ngStyle]="{
                        '--radio-color': settingsData?.font_secondary_color || '#3f51b5',
                        '--radio-label': settingsData?.font_secondary_color || '#3f51b5',
                      }"
                        class="mt-10"></mat-radio-button>
                </mat-radio-group>
                <!-- <img *ngIf="card?.brand == 'visa'" src="assets/payment-cards/VISA.svg">
                <img *ngIf="card?.brand == 'mastercard'" src="assets/payment-cards/Mastercard.svg">
                <img *ngIf="card?.brand == 'unionpay'" src="assets/payment-cards/China-Union-Pay.svg">
                <img *ngIf="card?.brand == 'diners'" src="assets/payment-cards/Dinners-Club.svg">
                <img *ngIf="card?.brand == 'discover'" src="assets/payment-cards/Discover.svg">
                <img *ngIf="card?.brand == 'japan-credit-bureau'" src="assets/payment-cards/Japan-Credit-Bureau.svg">
                <img *ngIf="card?.brand == 'amex'" src="assets/payment-cards/American-express.svg"> -->
                <span *ngIf="card?.brand == 'visa'">
                    <app-svg [icon]="'visa'"></app-svg>
                </span>
                <span *ngIf="card?.brand == 'mastercard'">
                    <app-svg [icon]="'mastercard'"></app-svg>
                </span>
                <span *ngIf="card?.brand == 'unionpay'">
                    <app-svg [icon]="'unionpay'"></app-svg>
                </span>
                <span *ngIf="card?.brand == 'diners'">
                    <app-svg [icon]="'diners'"></app-svg>
                </span>
                <span *ngIf="card?.brand == 'discover'">
                    <app-svg [icon]="'discover'"></app-svg>
                </span>
                <span *ngIf="card?.brand == 'japan-credit-bureau'">
                    <app-svg [icon]="'japan-credit-bureau'"></app-svg>
                </span>
                <span *ngIf="card?.brand == 'amex'">
                    <app-svg [icon]="'amex'"></app-svg>
                </span>
            </div>
            <div class=" col-7 col-md-7 text-right pr-0" [ngStyle]="{'color':settingsData?.font_secondary_color,'font-family': settingsData?.font_family ? settingsData?.font_family : ''}">
                <div class="fs-14">**** **** **** {{card?.last4}}</div>
                <div class="fs-14">{{card?.brand}}</div>
            </div>
        </div>
    </div>
</div>